module.exports = __webpack_public_path__ + "static/media/1.35ac9b03.mp3";